import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ appVersion = 'v2.0' }) => {
    return (
        <footer className="mt-8 border-t bg-white dark:bg-[#101419] border-gray-200 dark:border-gray-800 transition-colors">
            <div className="container mx-auto px-4 py-6 text-sm text-gray-600 dark:text-gray-400 flex flex-col lg:flex-row items-center justify-between gap-4">
                <div className="flex flex-col items-center lg:items-start gap-1">
                    <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 text-center lg:text-left">
                        <span className="text-gray-800 dark:text-gray-200 font-semibold">Plantlix {appVersion?.split('.').length >= 2 ? `${appVersion.split('.')[0]}.${appVersion.split('.')[1]}` : appVersion}</span>
                        <span>– Lernen macht Meister: Trainiere Pflanzenwissen effizient.</span>
                    </div>
                    <div className="text-xs text-gray-500 dark:text-gray-500 max-w-xl text-center lg:text-left mt-1">
                        Plantlix übernimmt keine Gewähr für die Richtigkeit der Pflanzendaten. Es wird nach und nach verbessert. Hilfe wird gerne angenommen.
                    </div>
                </div>
                <div className="flex flex-wrap items-center justify-center lg:justify-end gap-3 lg:gap-4 mt-2 lg:mt-0 text-center">
                    <Link to="/impressum" className="hover:text-plantlix-600 dark:hover:text-plantlix-400 transition-colors whitespace-nowrap">Impressum</Link>
                    <span className="text-gray-400">•</span>
                    <Link to="/datenschutz" className="hover:text-plantlix-600 dark:hover:text-plantlix-400 transition-colors">Datenschutz</Link>
                    <span className="text-gray-400">•</span>
                    <Link to="/changelog" className="hover:text-plantlix-600 dark:hover:text-plantlix-400 transition-colors">Changelog</Link>
                    <span className="text-gray-400">•</span>
                    <span>© {new Date().getFullYear()} Plantlix</span>
                    <span className="text-gray-400">•</span>
                    <Link to="/support" className="hover:text-plantlix-600 dark:hover:text-plantlix-400 transition-colors">💚 Spenden</Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
